// extracted by css-extract-rspack-plugin
export default {"cls1":"RatingCard-cls1_Vcv","cls2":"RatingCard-cls2_CaS RatingCard-cls1_Vcv"};